import React, { useRef } from "react";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function GiftingArt() {
    const sliderRef = useRef(null);

    const giftArtData = [
        { img: "/image/giftart-1.webp" },
        { img: "/image/giftart-2.webp" },
        { img: "/image/giftart-3.webp" },
        { img: "/image/giftart-4.webp" },
        { img: "/image/giftart-5.webp" },
        { img: "/image/giftart-6.webp" },
    ];

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
        responsive: [
            {
            breakpoint: 991,
            settings: { slidesToShow: 3, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true,}
            },
        ],
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
            <Icons name="arrowLeft" />
        </div>
        <div className="default-arrowright default-mobilearrow" onClick={() => sliderRef.current.slickNext()}>
            <Icons name="arrowRight" />
        </div>
        </>
    );

  return (
    <>
    <section className="giftpage-art">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <h4 className="heading center-heading">The Art of Wedding Gifting</h4>
                </div>

                {giftArtData.map((item, index) => (
                    <div className="col-lg-4 col-md-4 giftart-desktop" key={index}>
                        <div className="giftart-box">
                            <img src={item.img} className="img-responsive" alt="Wedding Gift" loading="lazy"/>
                        </div>
                    </div>
                ))}

                <div className="col-lg-12 giftart-mobile">
                    <div className="p-relative">
                        <Slider {...settings} ref={sliderRef}>
                            {giftArtData.map((item, index) => (
                            <div className="giftart-box" key={index}>
                                <img src={item.img} className="img-responsive" alt="Wedding Gift" loading="lazy"/>
                            </div>
                            ))}
                        </Slider>
                        <CustomArrows />
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
